// extracted by mini-css-extract-plugin
export default {"wrapper":"ModuleWrapper_wrapper__WgvbY"};